import { Component, OnInit, Input } from '@angular/core';
import { AccessService } from 'app/access.service';
import { MenuMappingService } from 'app/menu-mapping.service';

declare const $: any;
export interface RouteInfo {
  path?: string;
  title: string;
  icon?: string;
  class?: string;
  access?: boolean;
  children?: RouteInfo[];
  expanded?: boolean;
}
export const ROUTES: RouteInfo[] = [
  {
    title: 'Master',
    icon: 'people',
    class: '',
    children: [
      { path: 'state-master', title: 'State Master', icon: 'public', class: '' },
      { path: 'location-master', title: 'Location Master', icon: 'location_on', class: '' },
      { path: 'category', title: 'Category', icon: 'category', class: '' },
      { path: 'category-mapping', title: 'Category Mapping', icon: 'category', class: '' },
      { path: 'designation', title: 'Designation', icon: 'badge', class: '' },
      { path: 'papl-designation', title: 'PAPL Designation', icon: 'badge', class: '' },
      { path: 'esi-pf-mapping', title: 'Esi/Pf-code Mapping', icon: 'account_balance', class: '' },
      { path: 'earning', title: 'Earning', icon: 'attach_money', class: '' },
      { path: 'deduction', title: 'Deduction', icon: 'money_off', class: '' },
      { path: 'salary-range', title: 'Salary Range', icon: 'trending_up', class: '' },
      { path: 'profit-cost-center-manpower', title: 'Profit/Cost Center', icon: 'trending_up', class: '' },
      { path: 'department-master', title: 'Department Master', icon: 'linear_scale', class: '' },
      { path: 'slab-master', title: 'Slab Master', icon: 'linear_scale', class: '' },
      { path: 'grade-master', title: 'Grade Master', icon: 'leaderboard', class: '' },
      // { path: 'employee-grade', title: 'Employee Grade', icon: 'badge', class: '' },
      { path: 'attendance-calculation', title: 'Attendance Calculation', icon: 'fact_check', class: '' },
      { path: 'mastersetting', title: 'Salary Master Setting', icon: 'calculate', class: '' },
      { path: 'salary-calculation-formula', title: 'Salary Calculation Formula', icon: 'calculate', class: '' },
      { path: 'employee-list', title: 'All Employee List', icon: 'badge', class: '' },
      { path: 'profitcost-formula-mapping', title: 'Profit/Cost Center Formula Mapping', icon: 'account_tree', class: '' },
      { path: 'employee-formula-mapping', title: 'Employee Formula Mapping', icon: 'account_tree', class: '' },

    ]
  },
  {
    title: 'Enrollment',
    icon: 'how_to_reg',
    class: '',
    children: [
      { path: 'enrollment', title: 'Enrollment', icon: 'app_registration', class: '' },
      { path: 'first-posting', title: 'First Posting', icon: 'business_center', class: '' },
      { path: 'permanent-enrollment', title: 'Permanent Enrollment', icon: 'verified_user', class: '' },
      { path: 'temporary-exit', title: 'Exit Request List', icon: 'exit_to_app', class: '' },
      { path: 'blacklist-employee-record', title: 'Black List', icon: 'blocked', class: '' },
    ]
  },
  // {
  //   title: 'Attendance',
  //   icon: 'fact_check',
  //   class: '',
  //   children: [
  //   ]
  // },
  // {
  //   title: 'PostingHistory',
  //   icon: 'history',
  //   class: '',
  // children: [
  //   ]
  // },
  { path: 'daily-attendance', title: 'Daily Attendance', icon: 'calendar-days', class: '' },
  { path: 'posting-history', title: 'Posting History', icon: 'calendar_month', class: '' },
  {
    title: 'Salary',
    icon: 'history',
    class: '',
    children: [
      { path: 'salary-update-effective-date', title: 'Salary Update(Effective Date)', icon: 'calendar_month', class: '' },
      { path: 'salary-sheet', title: 'Salary Sheet', icon: 'sheets', class: '' },
    ]
  },
  {
    title: 'Leave Master',
    icon: 'event_note',
    class: '',
    children: [
      { path: 'leave-type', title: 'Leave Type', icon: 'category', class: '' },
      { path: 'leavepolicy', title: 'Leave Policy', icon: 'policy', class: '' },
      { path: 'leaverequest', title: 'Leave Request', icon: 'assignment', class: '' },
    ]
  },
  {
    title: 'Holidays',
    icon: 'event',
    class: '',
    children: [
      { path: 'holiday', title: 'Holiday Master', icon: 'event', class: '' },
      { path: 'holiday-calendar', title: 'Holiday Calendar', icon: 'calendar_month', class: '' },
      { path: 'holiday-master-branchwise', title: 'Holiday Master Branchwise', icon: 'calendar_month', class: '' },
    ]
  },
  { path: 'calculation-master', title: 'Calculation Master', icon: 'category', class: '' },
  { path: 'leave-details', title: 'Leave Details', icon: 'category', class: '' },

];

@Component({
  selector: 'app-peoplepulse-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: RouteInfo[] = [];
  userMenus: any[] = [];
  user_id: any;
  @Input() isCollapsed: boolean = false;

  constructor(
    private accessService: AccessService,
    private menuMappingService: MenuMappingService
  ) {
    // Get user ID from localStorage
    let userString = localStorage.getItem('data');
    let user = userString ? JSON.parse(userString) : {};
    this.user_id = user?.id;
  }

  ngOnInit() {
    this.loadUserMenusAndApplyAccess();
  }

  loadUserMenusAndApplyAccess() {
    if (this.user_id === 1) {
      this.menuItems = ROUTES.map(menu => this.setAccessRecursive(menu, true));
      return;
    }

    this.accessService.getUserMenusFromConfig().subscribe(
      (menus) => {
        this.userMenus = menus;
        this.menuItems = ROUTES.map(menu => this.applyMenuAccessRecursive(menu));
      },
      (error) => {
        console.error('Error fetching user menus:', error);
        this.menuItems = ROUTES.map(menu => this.setAccessRecursive(menu, true));
      }
    );
  }

  setAccessRecursive(menu: RouteInfo, access: boolean): RouteInfo {
    menu.access = access;
    if (menu.children) {
      menu.children = menu.children.map(child => this.setAccessRecursive(child, access));
    }
    return menu;
  }

  applyMenuAccessRecursive(menu: RouteInfo): RouteInfo {
    if (menu.children && menu.children.length > 0) {
      menu.children = menu.children.map(child => this.applyMenuAccessRecursive(child));
      menu.access = menu.children.some(child => child.access);
    } else if (menu.path) {
      menu.access = this.menuMappingService.hasMenuAccess(menu.path, this.userMenus);
    }
    return menu;
  }
  toggleMenu(menu: RouteInfo) {
    menu.expanded = !menu.expanded;
  }

  isMobileMenu(): boolean {
    return $(window).width() <= 991;
  }
}
